import React, { Component } from 'react';
import * as d3 from 'd3';

import VillagerAvatar from '../components/VillagerAvatar';
import Button from '../components/Button';
import Dialogue from '../components/Dialogue';


import ChartSpecs from '../data/chart_specs';

const colorWheelObj = ChartSpecs.chartspecs.colorWheelObjStar
var colorWheelArray = Object.keys(colorWheelObj);
var colorRange = Object.values(colorWheelObj);
var margin = ChartSpecs.chartspecs.marginAreabars;

class VillagerStarsign extends Component {
  constructor(props){
      super(props);
      this.state = {
        chartType: 'viewbyArea',
        selectedTier:1,
      }
      //this.svgRef = React.createRef();

      this.allVillagers = this.props.villagers;
      this.tierNodes = {};
      this.dataSet = [];

   }
   componentDidMount() {
     //this.svg = d3.select(this.svgRef.current);


     this.svg= d3.select(`#starsignChart`);

     this.tierNodes = d3.groups(this.allVillagers, d => d.tier, d => d.sign);
     this.tierNodes2 = d3.rollup(this.allVillagers, v => v.length, d => d.tier, d => d.sign);
     this.tierArray = [...this.tierNodes2.keys()];

     this.drawChart();

   }

   sliderRangeHandler(event){
      let selectedTier = event.target.value;
      this.setState({selectedTier: selectedTier});
      this.highlightTierBar(selectedTier);
   }

   highlightTierBar(selectedTier){
     let tableData = this.dataSet,
         tierArray = this.tierArray,
         chartWidth = this.svg.node().getBoundingClientRect().width,
         totalBarGroups = colorWheelArray.length,
         stackKeys=colorWheelArray,
         noOfColumns = 2,
         svg = this.svg;

     let noOfChartsPerCol = Math.round(totalBarGroups/noOfColumns);


     const yMaxArray = stackKeys.map(sign => {
       let max = d3.max(tableData, d => d[sign])
       return max;
     });

      const yMax = d3.max(yMaxArray, d => d);


     const xScale = d3.scaleBand()
                     .domain(tierArray)
                     .range([0, chartWidth/noOfColumns - margin.right])
                     //.padding(0.5)



      // Get the index of the xValue relative to the dataSet
      const dataIndex = tableData.findIndex(obj => obj.tier === Number(selectedTier))

    //  const leftData = (dataIndex === 0)? 0 :tableData[dataIndex-1];
      const leftData = tableData[dataIndex];
      const rightData = (dataIndex === 9)? 'max':tableData[dataIndex + 1];

      //d3.select('.year1').text(`${leftData.year} : ${leftData.popularity}`)
      //d3.select('.year2').text(`${rightData.year} : ${rightData.popularity}`)

      if(rightData === 'max'){
          svg.selectAll(".start").attr("offset", `${90}%`);
          svg.selectAll(".end").attr("offset", `${100}%`);
        }else{
          // Update gradient
          const x1Percentage = xScale(leftData.tier) / (chartWidth/noOfColumns - margin.right)  * 100;
          const x2Percentage = xScale(rightData.tier) / (chartWidth/noOfColumns - margin.right)  * 100;
          svg.selectAll(".start").attr("offset", `${x1Percentage}%`);
          svg.selectAll(".end").attr("offset", `${x2Percentage}%`);
        }
   }


   drawChart(){
     var svg = this.svg,
         chartWidth = this.svg.node().getBoundingClientRect().width,
         singleChartHeight = 40,
         stackKeys = colorWheelArray,
         totalBarGroups = colorWheelArray.length,
         strokeColor = 'rgba(1,124,116,1)',
         fillColor = 'rgba(1,124,116,0.5)',
         fillColorLight = 'rgba(1,124,116,0.1)',
         noOfColumns = 2;

     let chartHeight = singleChartHeight*totalBarGroups;


     svg.attr("id", 'starsignChart');
     svg.attr("height", chartHeight+margin.top*2);

     // Add gradient defs to svg https://codepen.io/louisemoxy/pen/eQGVyQ
      const defs = svg.append("defs");

      const gradient = defs.append("linearGradient").attr("id", "svgGradient");
      const gradientResetPercentage = "50%";

      gradient
        .append("stop")
        .attr("class", "start")
        .attr("offset", gradientResetPercentage)
        .attr("stop-color", fillColorLight);

      gradient
        .append("stop")
        .attr("class", "start")
        .attr("offset", gradientResetPercentage)
        .attr("stop-color", fillColor);

      gradient
        .append("stop")
        .attr("class", "end")
        .attr("offset", gradientResetPercentage)
        .attr("stop-color", fillColor)
        .attr("stop-opacity", 1);

      gradient
        .append("stop")
        .attr("class", "end")
        .attr("offset", gradientResetPercentage)
        .attr("stop-color", fillColorLight);


     let tierNodes2 = this.tierNodes2,
         tierArray = this.tierArray,
         noOfChartsPerCol = Math.round(totalBarGroups/noOfColumns);

     this.dataSet = Array.from(tierNodes2.entries())
      .map(g => {
        const obj = {};
        obj["tier"] = g[0];
        for (let col of stackKeys) {
          const vals = g[1].get(col);
          obj[col] = !vals ? 0 : vals;
        }
        return obj;
      })
     .sort((a, b) => a["tier"] - b["tier"]);


     let tableData = this.dataSet;

     const yMaxArray = stackKeys.map(sign => {
       let max = d3.max(tableData, d => d[sign])
       return max;
     });



      const yMax = d3.max(yMaxArray, d => d);


      const xScale = d3.scaleBand()
                      .domain(tierArray)
                      .range([margin.left, chartWidth/noOfColumns - margin.right])
                      //.padding(0.5)

      const yScale = d3.scaleLinear()
                      .domain([ 0, yMax ])
                      .range([chartHeight/noOfChartsPerCol - margin.top, margin.top/noOfChartsPerCol])

      const xAxis = g => g
                  .call(d3.axisBottom(xScale).tickFormat((d,i) => {
                   return (i%9 !== 0)  ? " ": `T.${d}` ;
                  }).tickSizeOuter(0))
                  .call(g => g.selectAll(".domain").remove());

      const yAxis = g => g
                .call(d3.axisLeft(yScale).ticks(2).tickSizeOuter(0))
                .call(g => g.selectAll(".domain").remove());


      // Creating the clone of the array
      let clonetableData = tableData.slice(0);

      const clonetableDataArr = tableData.map(d => ({ ...d}));

      // Extract the array using splice method
      let tableDataExtended = clonetableDataArr.splice(0,tierArray.length);

      const clonetableDataFirst = tableDataExtended[0];
      const clonetableDataLast = tableDataExtended[tierArray.length-1];

      //let tableDataExtended = tableData.slice();

      tableDataExtended.unshift(clonetableDataFirst);
      tableDataExtended.push(clonetableDataLast);

      let newFirst = tableDataExtended[0],
          newLast = tableDataExtended[tableDataExtended.length-1];

      stackKeys.forEach((sign, index) => {
        // define the area
        let area = d3.area()
            //.x(d => xScale(d.tier))
            .x((d,i) => {
              if(i === 0){
                return xScale.bandwidth()/2 + margin.left/2
              }else if(i === (tableDataExtended.length-1)){
                return xScale(d.tier) + xScale.bandwidth()/2
              }else{
                return xScale(d.tier)
              }
            })
            .y0(yScale(0))
            .y1(d => yScale(d[sign]))
            //.y1(d => d.tier === "Start" ? yScale(d[sign]) : yScale(d[sign]))
            .curve(d3.curveStep)

        // define the line
        let line = d3.line()
                  //.x(d => xScale(d.tier))
                  .y(d => yScale(d[sign]))
                  .x((d,i) => {
                    if(i === 0){
                      return xScale.bandwidth()/2 + margin.left/2
                    }else if(i === (tableDataExtended.length-1)){
                      return xScale(d.tier) + xScale.bandwidth()/2
                    }else{
                      return xScale(d.tier)
                    }
                  })
                  //.y(d => d.tier === "Start" ? yScale(d[firstSign]) : yScale(d[sign]))
                  .curve(d3.curveStep)



       let group = svg.append("g")
         .attr('class', `path-${sign}`);


       let barLabels = svg.append("g")
           .attr('class', `bar-label-${sign}`)

       let chartLabels = svg.append("g")
           .attr('class', `chart-label-${sign}`)

       // Add the area
       group.append('path')
           .datum(tableDataExtended)
           .attr('class', `path-goodlooking`)
           .style('fill', "url(#svgGradient)")
           .attr("d",area)

      // Add the line
       group.append("path")
          .datum(tableDataExtended)
          .attr("fill", "none")
          .attr("stroke", strokeColor)
          .attr("stroke-width", 2)
          .attr("d", line)

      chartLabels.append('text')
          .attr('class', 'chart-label')
          .attr("x", d => 0)
          .attr('y', d => yScale(yMax/2))
          .attr("dy", "0em")
          .text(d => `${sign}`);


        if(index < noOfChartsPerCol){
          svg.append("g")
          .attr("transform", `translate(${-margin.right/6}, ${chartHeight + margin.top})`)
          .attr("class", 'xaxis tier-axis no-tick gap-tick')
          .call(xAxis);

          svg.append("g")
          .attr("transform", `translate(${margin.left/1.25}, ${margin.top/noOfColumns + index*(chartHeight/noOfChartsPerCol)+ index*margin.top/4})`)
          .attr("class", 'yaxis')
          .call(yAxis);

          chartLabels.attr("transform", `translate(${chartWidth/noOfColumns - margin.right}, ${(0)+ index*(chartHeight/noOfChartsPerCol) + index*margin.top/4}) rotate(0)`)
          .attr("text-anchor", "end")

          group.attr("transform", `translate(${0  + margin.right/6}, ${margin.top/2 + index*(chartHeight/noOfChartsPerCol)+ index*margin.top/4})`)

          barLabels.attr("transform", `translate(${chartWidth/noOfColumns - margin.right/2.25}, ${margin.top/1.5 + index*(chartHeight/noOfChartsPerCol)+index*margin.top/4}) rotate(0)`)

        }else{
          svg.append("g")
          .attr("transform", `translate(${chartWidth/noOfColumns-margin.right/6}, ${chartHeight + margin.top})`)
          .attr("class", 'xaxis tier-axis no-tick gap-tick')
          .call(xAxis);

         svg.append("g")
          .attr("transform", `translate(${chartWidth/noOfColumns + margin.left/1.25}, ${margin.top/noOfColumns + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol) + (index-noOfChartsPerCol)*margin.top/4})`)
          .attr("class", 'yaxis')
          .call(yAxis);

          chartLabels.attr("transform", `translate(${chartWidth - margin.right}, ${(0) + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*margin.top/4}) rotate(0)`)
          .attr("text-anchor", "end")

          group.attr("transform", `translate(${chartWidth/noOfColumns + margin.right/6}, ${margin.top/2 + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+(index-noOfChartsPerCol)*margin.top/4})`)

          barLabels.attr("transform", `translate(${chartWidth - margin.right/2.25}, ${margin.top/1.5 + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+(index-noOfChartsPerCol)*margin.top/4}) rotate(0)`)

        }

      });
        this.highlightTierBar(this.state.selectedTier);

   }

  render() {

    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-traits">
        <h2 className="title">Villager star sign</h2>
        <p className="paragraph">Each Animal Crossing villager has a birthday, which also means that they have a zodiac star sign. Some star signs tend to be popular amongst astrology lovers, so we wondered if that translated at all into the Animal Crossing world.</p>

        <div className='tier-slider'>
            <label htmlFor="starsignTierSlider" className='slider-label' aria-label="Tier slider"></label>
            <input type="range"
            id="starsignTierSlider"
            min="1"
            max="10"
            value={this.state.selectedTier}
            onChange={this.sliderRangeHandler.bind(this)}
            step="1"
            className='slider-input'/>
            <output htmlFor="starsignTierSlider" id="starsignTierSlider-output" style={{left: `calc(${parseInt(this.state.selectedTier)*10}% - ${(parseInt(this.state.selectedTier)/10)*72}px - ${3.9*(10-parseInt(this.state.selectedTier))}px)`}} className='slider-output'>Tier {this.state.selectedTier}</output>
        </div>
      {/*  <svg ref={this.svgRef} width="100%"></svg> */}
        <svg id='starsignChart' width="100%"></svg>

        <p className="paragraph"> While there are obvious peaks and valleys across each star sign’s distribution curve, the differences between high and low bars is generally 5 or less, and it is hard to see any overall increasing or decreasing patterns.</p>
        <Dialogue title="Summary" type="regular">
          <p className="paragraph"> Overall, it doesn’t look like any star signs are particularly favored or unfavored in popularity.  </p>
        </Dialogue>
      </div>
    )
  }
}
export default VillagerStarsign;
